import EditableCell from "@components/EditableCell"
import { getTableRows } from "@features/graph/details/components/TableNodeDetails/helpers"
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import { BaseGraphTableNode } from "@store/services/converter/types"

export type CellOption = {
  editable?: boolean
  onBlur: (
    field: keyof BaseGraphTableNode,
    rowIndex: number,
    cellIndex: number,
    newValue: string,
  ) => void
}

type NodeTableProps = {
  editable?: boolean
  table: BaseGraphTableNode
  onBlur: CellOption["onBlur"]
}

const NodeTable = ({ editable = false, onBlur, table }: NodeTableProps) => {
  const rows = getTableRows(table, { editable, onBlur })

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {/* add extra header for index at the beggining */}
            {["", ...table.columns].map((column) => (
              <TableCell key={column}>
                <strong>{column}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((cells, i) => (
            <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              {cells.map((cell, j) => (
                <EditableCell key={j} {...cell} />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default NodeTable
